export default __webpack_public_path__ + "c87a7bccce13d2983f3385c179926930.svg";